import { systemArchitectureModule } from './modules/system-architecture';
import { microservicesDesignModule } from './modules/microservices-design';
import { integrationPatternsModule } from './modules/integration-patterns';
import { PERFORMANCE_OPTIMIZATION_MODULE } from './modules/performance-optimization';

export const systemDesignCourse = {
  id: 'enterprise-system-design',
  title: 'Enterprise System Design & Architecture',
  description: 'Design scalable, maintainable enterprise systems and microservices architectures',
  level: 'advanced',
  totalDuration: '20 hours',
  image: '/api/placeholder/400/300',
  prerequisites: ['Software development experience', 'Database knowledge'],
  learningOutcomes: [
    'Design scalable distributed systems for enterprise use',
    'Implement microservices architecture patterns',
    'Plan system integration and API design strategies',
    'Optimize performance and reliability for enterprise scale'
  ],
  modules: [
    { ...systemArchitectureModule, order: 1, estimatedTime: systemArchitectureModule.duration },
    { ...microservicesDesignModule, order: 2, estimatedTime: microservicesDesignModule.duration },
    { ...integrationPatternsModule, order: 3, estimatedTime: integrationPatternsModule.duration },
    { ...PERFORMANCE_OPTIMIZATION_MODULE, order: 4, estimatedTime: PERFORMANCE_OPTIMIZATION_MODULE.duration }
  ]
};